var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"main",staticClass:"transition__main"},[_c('transition',{attrs:{"appear":"","mode":"out-in"},on:{"enter":_vm.handleEnter,"leave":_vm.handleLeave}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }